const DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/;

function pad2(value) {
  return String(value).padStart(2, "0");
}

function isValidDateParts(year, month, day) {
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

/**
 * Normalize a backend DATE value for APIs that expect YYYY-MM-DD.
 * For ISO/DATETIME strings, preserve the literal calendar date instead of
 * converting time zones; a SQL DATE has no instant or time-zone semantics.
 *
 * @param {Date|string|number|null|undefined} input
 * @returns {string}
 */
export function toServerDate(input) {
  if (input == null || input === "") return "";

  if (typeof input === "string") {
    const value = input.trim();
    const match = value.match(DATE_PREFIX);
    if (match) {
      const year = Number(match[1]);
      const month = Number(match[2]);
      const day = Number(match[3]);
      return isValidDateParts(year, month, day)
        ? `${match[1]}-${match[2]}-${match[3]}`
        : "";
    }
  }

  const date = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(date.getTime())) return "";
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(
    date.getDate()
  )}`;
}

/** Parse the server's local date-time format consistently, including Safari. */
export function toTimestamp(input) {
  if (input == null || input === '') return NaN;
  let date;
  if (typeof input === 'string') {
    const match = input.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/);
    date = match
      ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]), Number(match[4]), Number(match[5]), Number(match[6]))
      : new Date(input);
  } else {
    date = input instanceof Date ? input : new Date(input);
  }
  return date.getTime();
}

/** Display backend local date-times without interpreting them as UTC. */
export function toDisplay(input, mode = 'datetime') {
  const date = new Date(toTimestamp(input));
  if (Number.isNaN(date.getTime())) return '—';
  const day = toServerDate(date);
  const clock = `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
  if (mode === 'date') return day;
  if (mode === 'time') return clock;
  if (mode === 'axis') return clock.slice(0, 5);
  if (mode === 'day-axis') return `${day.slice(5)} ${clock.slice(0, 5)}`;
  return `${day} ${clock}`;
}
